import { t } from "i18next";
import { useLocation } from "react-router-dom";
import { Module } from "../../ui/components/Module";
import { NavigationMenu } from "../../../models/NavigationMenu";
import { BreadcrumbItem } from "../../ui/models/BreadcrumbItem";
import { useHasAnyPermission } from "../../core/hooks/useHasAnyPermission";
import { UserPermissions } from "../../core/models/UserPermissions";

export const ChatbotNavigation = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const hasWingmanAdmin = useHasAnyPermission(UserPermissions.WingmanSourceAdmin);

  const menu: NavigationMenu = {
    items: [
      {
        title: t`Wingman`,
        path: "chat"
      },
      ...(hasWingmanAdmin ? [{ title: t`Admin`, path: "admin" }] : [])
    ],
    parentPath: currentPath,
  };

  const breadcrumb: BreadcrumbItem = {
    title: t`Home`,
    path: "home",
    alwaysShow: true,
    children: [
      {
        title: t`Wingman`,
        path: "/wingman",
      },
      ...(hasWingmanAdmin ? [{ title: t`Admin`, path: "/admin" }] : [])
    ],
  };

  return <Module menu={menu} breadcrumb={breadcrumb} />;
};
